import type { PillIntent } from '@/_components';
import type { IconType } from '@/_types/icons';
import { SignatureRequestColumnType } from '@/_types/signatureRequest';

export interface SignatureRequestStatus {
  icon: IconType;
  intent: PillIntent;
  text: string;
  value: string;
}

export const SIGNATURE_REQUEST_PATH = '/_soraban/Signature Requests' as const;

export const SIGNATURE_REQUEST_TABLE_HEADER_MAP: Record<
  SignatureRequestColumnType,
  string
> = {
  company_name: 'Entity Name',
  tax_year: 'Year',
  document_name: 'Document Name',
  status: 'Status',
  updated_at: 'Last Activity',
  actions: '',
};

export const SIGNATURE_REQUEST_STATUSES: Array<SignatureRequestStatus> = [
  {
    value: 'sending',
    text: 'Sending',
    icon: 'email',
    intent: 'default',
  },
  {
    value: 'sent',
    text: 'Sent',
    icon: 'email',
    intent: 'info',
  },
  {
    value: 'signed',
    text: 'Signed',
    icon: 'check-circle',
    intent: 'success',
  },
  {
    value: 'completed',
    text: 'Completed',
    icon: 'checks',
    intent: 'success',
  },
  {
    value: 'error',
    text: 'Error',
    icon: 'x',
    intent: 'danger',
  },
  {
    value: 'processing',
    text: 'Processing',
    icon: 'circle',
    intent: 'default',
  },
  {
    value: 'action_required',
    text: 'Action required',
    icon: 'warning',
    intent: 'warning',
  },
];
